import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconComponent, PlIconPrivateComponent } from './pl-icon.component';

@NgModule({
  declarations: [PlIconPrivateComponent, PlIconComponent],
  exports: [PlIconComponent],
  imports: [CommonModule],
})
export class PlIconModule {}
